<template>
  <div class="mdx-container mt-3 pa-3 mx-3">
    <component
      v-if="comp"
      :is="comp" />
    <div v-else>
      No MDX File Found under that name, did you add it to helpComponents in
      doc-components.js?
    </div>
  </div>
</template>
<script setup>
const props = defineProps(['comp']);
</script>

<style>
/* Note
I've not used the scoped attribute above as this breaks the code below.
This overrides the margin: 0, and padding: 0 from the index.css (vuetify?)
*/

/* Override */
.mdx-container * {
  margin: revert;
  padding: revert;
}

.mdx-container {
  color: var(--text);
  border-radius: 5px;
  overflow-y: auto;
  max-height: 500px;
  margin-bottom: 20px;
}

.mdx-container h1:first-child {
  margin-top: 0;
}
</style>
